import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { PlusOutline } from '@lyearn/icons';
import { Box, InfoPill } from '@lyearn/ui';
import Filter from '@/components/Filter';
import { FilterOption } from '@/components/Filter/types';
import { SkillItemRenderer } from '@/modules/corporate/modules/feedback/views/FeedbackWall/components/CreateFeedbackModal/components/RelatedSkillsOrMindsets/utils';

import usePraiseRelatedMindsets from '../../../../hooks/usePraiseRelatedMindsets';
import { MENU_LIST_OVERRIDES } from '../PraiseRelatedSkills/styles';
import SelectedSkillPill from '../SelectedSkillPill';
import { PraiseRelatedMindsetsProps } from './types';

const EMPTY_ARRAY: never[] = [];

const PraiseRelatedMindsets: React.FC<PraiseRelatedMindsetsProps> = (props) => {
  const { value, receiverUsers, onChange } = props;
  const { t } = useTranslation(['Feedback']);

  const userIds = useMemo(() => receiverUsers.map((user) => user.id), [receiverUsers]);

  const {
    searchText,
    setSearchText,
    selectedMindsets,
    filterGroups,
    open,
    toggle,
    onAddMindset,
    selectedMindsetsState,
    onRemoveMindset,
  } = usePraiseRelatedMindsets({
    userIds,
    mindsetRatings: value,
    onChange,
  });

  return (
    <Box className="flex flex-row flex-wrap">
      <Filter
        asyncOptions={{
          search: {
            placeholder: t('Praises:Form.SearchMindsets'),
            value: searchText,
            onChange: setSearchText,
          },
        }}
        emptyLabel={
          userIds.length ? t('Feedback:NoMindsetsDesc') : t('Feedback:NoUserSelectedMindsetsDesc')
        }
        groups={filterGroups}
        itemRenderer={SkillItemRenderer}
        open={open}
        overrides={MENU_LIST_OVERRIDES}
        showActionButtons={false}
        value={(selectedMindsetsState || EMPTY_ARRAY) as FilterOption[]}
        onChange={onAddMindset}
        onClose={toggle}
        onToggle={toggle}>
        <InfoPill
          Icon={PlusOutline}
          className="mb-8 me-8"
          label={t('Praises:Form.AddMindsets')}
          shape="round"
          type="icon"
          variant="outlined"
        />
      </Filter>
      {selectedMindsets?.map((mindset) => (
        <SelectedSkillPill
          key={mindset.id}
          label={mindset.name}
          onRemove={() => onRemoveMindset(mindset.id)}
        />
      ))}
    </Box>
  );
};

export default PraiseRelatedMindsets;
